exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer[data-v-757217e3]{position:relative;display:inline-block;margin:0 10px;padding-top:inherit+100px}.inner[data-v-757217e3]{top:104%;left:50%;-webkit-padding-before:30px;padding-block-start:30px;-webkit-padding-after:10px;padding-block-end:10px}.icorta[data-v-757217e3],.inner[data-v-757217e3]{position:absolute}.icorta[data-v-757217e3]{margin:0 auto;height:226px;color:#fff;left:92%;top:95%;margin-left:-110px;margin-top:-15px}.rotate[data-v-757217e3]{-webkit-transform:translateX(-50%) translateY(-50%) rotate(-90deg);transform:translateX(-50%) translateY(-50%) rotate(-90deg)}", ""]);

// exports
